<template>
    <div class="pro_container">
        <global-tag>
            <span slot="title">项目管理</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="项目名称：">
                                <el-input
                                    v-model="projectName"
                                    placeholder="请输入项目名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="开始时间：">
                                <el-date-picker
                                    v-model="startTime"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="请选择开始时间"
                                    @change="startTimeChange"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="结束时间：">
                                <el-date-picker
                                    v-model="endTime"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="请选择结束时间"
                                    @change="endTimeChange"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="showList"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="emptySearch"
                                >清除条件</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="searchButtonDiveRight">
                <el-button-group>
                    <el-button
                        type="primary"
                        class="dropRests"
                        icon="el-icon-refresh"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox
                                    ><br />
                                    <el-checkbox label="项目名称"></el-checkbox
                                    ><br />
                                    <el-checkbox label="开始时间"></el-checkbox
                                    ><br />
                                    <el-checkbox label="结束时间"></el-checkbox
                                    ><br />
                                    <el-checkbox label="简介"></el-checkbox
                                    ><br />
                                    <el-checkbox label="创建人"></el-checkbox
                                    ><br />
                                    <el-checkbox label="创建时间"></el-checkbox
                                    ><br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <!-- <el-table-column
          type="selection"
          width="80"
          align="center"
        ></el-table-column> -->
                <el-table-column
                    type="index"
                    width="60px"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="projectName"
                    min-width="100px"
                    label="项目名称"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '项目名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="startTime"
                    min-width="150px"
                    label="开始时间"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '开始时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="endTime"
                    min-width="100px"
                    label="结束时间"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '结束时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="brief"
                    min-width="60px"
                    label="简介"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '简介'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="createDate"
                    min-width="150px"
                    label="创建时间"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    min-width="60px"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="编辑"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_edit.png"
                                @click="handleTableForm('编辑', scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt=""
                                @click="deleteItem(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <!-- tbale 新增删除修改弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="40%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    :model="formData"
                    ref="formData"
                    :rules="formDataRules"
                    :disabled="dialogVisibleTitle == '详情'"
                >
                    <el-form-item label="项目名称：" prop="projectName">
                        <el-input v-model="formData.projectName"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间：" prop="startTime">
                        <el-date-picker
                            v-model="formData.startTime"
                            type="date"
                            style="width: 100%"
                            placeholder="请选择开始时间"
                            value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="endTime">
                        <el-date-picker
                            v-model="formData.endTime"
                            type="date"
                            style="width: 100%"
                            placeholder="请选择开始时间"
                            value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="简介：">
                        <el-input
                            type="textarea"
                            v-model="formData.brief"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="所属机构:">
                        <el-cascader
                            :options="orgList"
                            v-model="formData.dataId"
                            style="width: 100%"
                            v-if="dialogVisibleTitle == '新增'"
                            :props="{
                                checkStrictly: true,
                                emitPath: false,
                                label: 'label',
                                value: 'orgId',
                            }"
                        ></el-cascader>
                        <el-input
                            v-model="formData.dataName"
                            disabled
                            v-else
                        ></el-input>
                    </el-form-item>
                    <div class="table_add_wraoper">
                        <el-button
                            type="success"
                            icon="iconfont icon-xinzeng"
                            @click="handleTableAddForm('新增')"
                            >新增</el-button
                        >
                        <div class="add_table">
                            <el-table
                                height="200"
                                :data="formData.subProManageList"
                                tooltip-effect="dark"
                                style="width: 100%"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    align="center"
                                    type="index"
                                    label="序号"
                                    width="60"
                                ></el-table-column>
                                <!-- <el-table-column
                  align="center"
                  prop="renovateProject"
                  label="改造项目"
                  :show-overflow-tooltip="true"
                ></el-table-column> -->
                                <el-table-column
                                    align="center"
                                    prop="label"
                                    label="产品名称"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="internalPrice"
                                    label="内部采购价"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="openPrice"
                                    label="公开价"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="operation"
                                    label="操作"
                                    align="center"
                                    width="140px"
                                    v-if="dialogVisibleTitle != '详情'"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            effect="dark"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <img
                                                src="../assets/img/table_edit.png"
                                                @click="
                                                    handleTableAddForm(
                                                        '编辑',
                                                        scope
                                                    )
                                                "
                                                style="
                                                    margin-left: 12px;
                                                    cursor: pointer;
                                                "
                                            />
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <img
                                                src="../assets/img/table_delete.png"
                                                alt=""
                                                style="
                                                    margin-left: 12px;
                                                    cursor: pointer;
                                                "
                                                @click="
                                                    handleTableAddForm(
                                                        '删除',
                                                        scope
                                                    )
                                                "
                                            />
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- <div class="pagination_container">
              <el-pagination
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="6"
              ></el-pagination>
            </div> -->
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="isdisabled" @click="save"
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- tbale 里面新增删除修改弹窗 -->
        <el-dialog
            :title="addDialogTitle"
            :visible.sync="addDialog"
            width="60%"
            class="dialog_container"
            @close="addDialogClose"
        >
            <div class="dialog_content">
                <el-form label-position="left" label-width="100px">
                    <!-- ref="addFormData" :model="addFormData" :rules="addFormDataRules" -->
                    <!-- <el-form-item label="改造项目：" prop="renovateProject">
            <el-input v-model="addFormData.renovateProject"></el-input>
          </el-form-item> -->
                    <!--  v-show="AddDialogType == '编辑'" -->
                    <div
                        class="fixed"
                        @click="handelAddProblem"
                        v-show="addDialogTitle == '新增'"
                    >
                        <i class="el-icon-plus"></i>
                    </div>
                    <el-row>
                        <template v-for="(item, i) in addFormData">
                            <div :key="i">
                                <el-col :span="8">
                                    <el-form-item label="产品名称：">
                                        <el-select
                                            v-model="item.productName"
                                            value-key="index"
                                            placeholder="请选择"
                                            style="width: 100%"
                                            @change="
                                                productNameChange(
                                                    $event,
                                                    i,
                                                    item
                                                )
                                            "
                                        >
                                            <el-option
                                                v-for="(
                                                    child, index
                                                ) in productNameList"
                                                :key="index"
                                                :label="child.productName"
                                                :value="child.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7" :offset="1">
                                    <el-form-item label="内部采购价：">
                                        <el-input
                                            v-model.trim="item.internalPrice"
                                            :disabled="true"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7" :offset="1">
                                    <el-form-item label="公开价：">
                                        <el-input
                                            v-model.trim="item.openPrice"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </template>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="typeList">确 定</el-button>
                <el-button @click="addDialog = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import globalTag from "../components/globalTag"
import common from "../../../utils/common.js"
import { parseTime } from "@/utils/utils"
export default {
    name: "proManage",
    data() {
        return {
            isdisabled: false,
            orgList: [],
            orgLevels: "",
            hcai: {},
            pageSize: 10,
            total: 0,
            pageNo: 1,
            proName: "", //项目名称
            startTime: "", //开始时间
            endTime: "", //结束时间
            tableData: [],
            projectName: "",
            tempTableChekbox: [
                "序号",
                "项目名称",
                "开始时间",
                "结束时间",
                "简介",
                "创建人",
                "创建时间",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "项目名称",
                "开始时间",
                "结束时间",
                "简介",
                "创建人",
                "创建时间",
                "操作",
            ],
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            formData: {
                subProManageList: [],
                brief: "",
                endTime: "",
                startTime: "",
                projectName: "",
                dataId: "",
                shengjiId: "",
                qujiId: "",
                shijiId: "",
                stationId: "",
                shequjiId: "",
            },
            formDataRules: {
                projectName: [
                    {
                        required: true,
                        message: "项目名称不能为空",
                        trigger: "blur",
                    },
                ],
                startTime: [
                    {
                        required: true,
                        message: "开始时间不能为空",
                        trigger: "blur",
                    },
                ],
                endTime: [
                    {
                        required: true,
                        message: "结束时间不能为空",
                        trigger: "blur",
                    },
                ],
                dataId: [
                    {
                        required: true,
                        message: "组织机构不能为空",
                        trigger: "change",
                    },
                ],
            },
            addDialog: false, //table表单弹窗里面新增表单
            addDialogTitle: "", //table表单弹窗里面新增表单title
            addFormData: [
                //table表单弹窗里面新增表form
                {
                    productName: "", //产品名称
                    internalPrice: "", //内部采购价
                    openPrice: "", //公开价
                },
            ],
            addFormDataRules: {
                renovateProject: [
                    {
                        required: true,
                        message: "改造项目不能为空",
                        trigger: "blur",
                    },
                ],
                productName: [
                    {
                        required: true,
                        message: "产品名称不能为空",
                        trigger: "blur",
                    },
                ],
                unitPrice: [
                    {
                        required: true,
                        message: "单价不能为空",
                        trigger: "blur",
                    },
                ],
            },
            currentSubProManage: "",
            addFormIndex: "",
            productNameList: [],
            arrOrgList: [],
        }
    },
    components: {
        globalTag,
    },
    created() {
        this.getOrg()
        this.showList()
    },
    methods: {
        // 获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {
                        isValid: 1,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200 && res.content) {
                        let item = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        this.orgList.push(item)
                        // console.log(this.orgList)
                    }
                })
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        //产品列表发生变化
        productNameChange(val, i, child) {
            let arr = this.productNameList
            arr.forEach((item, index, arr) => {
                if (arr[index].id == val) {
                    child.internalPrice = arr[index].internalPurchasePrice
                    child.label = arr[index].productName
                    child.productId = arr[index].id
                }
            })
        },
        //获取产品列表
        getFindList() {
            // console.log(this.formData.dataId)
            this.$http
                .request({
                    url: "/jjyl/admin/productManage/info/findList",
                    method: "POST",
                    data: {
                        pageSize: 1000,
                        pageNo: 1,
                        dataId: this.formData.dataId,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.productNameList = []
                            return
                        }
                        this.productNameList = res.content.list
                    }
                })
        },
        handelAddProblem() {
            this.addFormData.push({
                productName: "", //产品名称
                internalPrice: "", //内部采购价
                openPrice: "", //公开价
            })
        },
        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            this.showList()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            this.showList()
        },
        //搜索开始时间格式化
        startTimeChange(val) {
            let temp = parseTime(val.getTime())
            this.startTime = temp
        },
        //搜索结束时间
        endTimeChange(val) {
            let temp = parseTime(val.getTime())
            this.endTime = temp
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //处理table表格表单
        handleTableForm(title, row) {
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.isdisabled = false
            switch (title) {
                case "详情":
                    this.look(row)
                    break
                case "编辑":
                    this.look(row)
                    break
            }
        },
        //表单内新增
        handleTableAddForm(title, params) {
            if (this.formData.dataId) {
                this.getFindList()

                if (title == "删除") {
                    let temp = this.formData.subProManageList.filter(
                        (item, index) => {
                            return index != params.$index
                        }
                    )
                    this.$set(this.formData, "subProManageList", temp)
                    this.$forceUpdate()
                    return
                }
                if (title == "编辑") {
                    let date = { ...params.row }
                    this.addFormIndex = params.$index
                    this.addFormData = []
                    this.addFormData.push(date)
                }
                this.addDialogTitle = title
                this.addDialog = true
            } else {
                this.$message({
                    message: "请先选择所属机构",
                    type: "warning",
                })
            }
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.formData.subProManageList = []
            this.formData.brief = ""
            this.formData.endTime = ""
            this.formData.startTime = ""
            this.formData.projectName = ""
            this.formData.id = ""
            this.formData.dataId = ""
            this.hcai = {}
            this.addFormData.productName = "" //产品名称
            this.addFormData.internalPrice = "" //内部采购价
            this.addFormData.openPrice = "" //公开价
            this.$refs.formData.resetFields()
        },
        //table表格表单新增弹窗关闭时事件
        addDialogClose() {
            this.addFormData = [
                {
                    productName: "",
                    internalPrice: "",
                    openPrice: "",
                },
            ]
        },

        typeList() {
            for (let i = 0; i < this.addFormData.length; i++) {
                if (
                    this.addFormData[i].productName === "" ||
                    //  this.addFormData[i].internalPrice === "" ||
                    this.addFormData[i].openPrice === ""
                ) {
                    this.$message.error("产品名称或公开价不能为空，请填写")
                    return
                }
            }
            let temp = [...this.addFormData]
            if (this.addDialogTitle == "新增") {
                this.formData.subProManageList.unshift(...temp)
            }
            if (this.addDialogTitle == "编辑") {
                this.$set(
                    this.formData.subProManageList,
                    this.addFormIndex,
                    temp[0]
                )
            }
            this.addDialog = false
        },

        //清空搜索条件
        emptySearch() {
            this.pageSize = 10
            this.pageNo = 1
            this.startTime = ""
            this.endTime = this.projectName = ""
            this.showList()
        },
        //获取表格数据
        showList(s) {
            request({
                url: "/jjyl/admin/projectManage/info/findList",
                method: "POST",
                data: {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    startTime: s === true ? "" : this.startTime,
                    endTime: s === true ? "" : this.endTime,
                    projectName: s === true ? "" : this.projectName,
                    qujiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .qujiId,
                    shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shengjiId,
                    shijiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shijiId,
                    stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .stationId,
                    shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shequjiId,
                },
            }).then((res) => {
                if (res.content == null || res.content == "null") {
                    this.tableData = []
                    this.total = 0
                    this.pageSize = 10
                    this.pageNo = 1
                    return
                }
                this.tableData = res.content.list
                this.total = res.content.count
            })
        },
        //新增项目保存
        save() {
            if (this.dialogVisibleTitle == "详情") {
                this.dialogVisible = false
                return
            }
            let url = ""
            if (this.dialogVisibleTitle == "新增") {
                url = "/jjyl/admin/projectManage/info/insert"
            }
            if (this.dialogVisibleTitle == "编辑") {
                url = "/jjyl/admin/projectManage/info/update"
            }
            this.formData.subProManageList.forEach((item) => {
                delete item.id
            })

            this.$refs["formData"].validate((valid) => {
                let obj = common.organization(this.arrOrgList, this.orgLevels)
                if (valid) {
                    this.isdisabled = true
                    request({
                        url,
                        method: "POST",
                        data: {
                            pageNo: this.pageNo,
                            pageSize: this.pageSize,
                            ...this.formData,
                            orgId: obj.orgId,
                            qujiId: obj.qujiId,
                            shengjiId: obj.shengjiId,
                            shijiId: obj.shijiId,
                            stationId: obj.stationId,
                            shequjiId: obj.shequjiId,
                            createPersonName: this.$store.state.info.name,
                        },
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message.success("保存成功")
                            this.showList()
                        } else {
                            this.$message.error("保存失败")
                        }
                        this.dialogVisible = false
                    })
                } else {
                    return false
                }
            })
        },
        look(date) {
            let that = this
            request({
                url: "/jjyl/admin/projectManage/info/getById",
                method: "POST",
                data: {
                    id: date.id,
                },
            }).then((res) => {
                that.formData = res.content
                that.formData.dataName = that.getDataName(
                    that.orgList,
                    res.content.dataId
                )

                that.getFindList()
            })
        },
        getDataName(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a.label
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/projectManage/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success("删除成功")
                        this.showList()
                    }
                })
            })
        },
        // 保留条件刷新
        Reset1() {
            this.showList(true)
            this.tableChekbox = [
                "序号",
                "项目名称",
                "开始时间",
                "结束时间",
                "简介",
                "创建人",
                "创建时间",
                "操作",
            ]
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
    },
    inject: ["reload"], //注入
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}

.fixed {
    position: absolute;
    right: 20px;
    top: 90px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
}
.add_table1 {
    // height: calc(100vh - 1.2rem);
    height: 200px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
</style>

<style lang="less">
.gutter {
    background-color: #e6e6e6 !important;
    border-right: 1px solid #e6e6e6 !important;
}
</style>
